import CarouselItemWithContent from './CarouselItemWithContent'

export * from './CarouselItemWithContent'

export default CarouselItemWithContent
